import React from 'react';
import PropTypes from 'prop-types';

import {DownloadTemplate, SidePanel, UploadProjectSharedDocument} from 'front-onceforall-core';

import {pathDocumentTemplates} from '../../../../utils/path';

const TEMPLATE_STEP_INDEX = 1;
const UPLOAD_STEP_INDEX = 2;

export function DownloadAndUploadProjectSharedDocumentPanel(props) {
  const [currentStep, setCurrentStep] = React.useState(TEMPLATE_STEP_INDEX);

  function handleNextStep() {
    setCurrentStep(UPLOAD_STEP_INDEX);
  }

  function handlePreviousStep() {
    setCurrentStep(TEMPLATE_STEP_INDEX);
  }

  function getStep() {
    if (currentStep === TEMPLATE_STEP_INDEX) {
      return (<DownloadTemplate
        document={props.document}
        onClose={props.onClose}
        onHandleSubmit={handleNextStep}
        pathDocumentTemplate={pathDocumentTemplates + props.documentTemplate}
      />);
    }

    return (<UploadProjectSharedDocument
      onCancel={handlePreviousStep}
      onHandleSubmitFile={props.onHandleSubmitFile}
      submitted={props.submitting}
      extensions={props.extensions}
      showAdditionalDesignation={false}
    />);
  }

  return (
    <SidePanel
      big
      onClose={props.onClose}
    >
      {getStep()}
    </SidePanel>
  );
}

DownloadAndUploadProjectSharedDocumentPanel.defaultProps = {
  extensions: '.docx'
};

DownloadAndUploadProjectSharedDocumentPanel.propTypes = {
  documentTemplate: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  document: PropTypes.object.isRequired,
  onHandleSubmitFile: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  extensions: PropTypes.string
};

export default DownloadAndUploadProjectSharedDocumentPanel;
